/* eslint-disable react/jsx-pascal-case */
import React, {useEffect, useState} from 'react';
import Login from "./Login/Login";
import Registration from "./Registration/Registration";
import styles from './Authentication.module.css'
import RegistrationSuccess from "./RegistrationSuccess/RegistrationSuccess";
import {CircleLoader} from "react-spinners";
import {useAppSelector} from "../../hooks/redux";
import {getIsAuthLoading} from "../../store/selectors/authSelector";
import clsx from "clsx";
import Authentication_RecoveryPassword from "./Authentication_RecoveryPassword/Authentication_RecoveryPassword";
import Authentication_RecoveryPasswordSuccess
    from "./Authentication_RecoveryPassword/Authentication_RecoveryPasswordSuccess/Authentication_RecoveryPasswordSuccess";

export enum EnumAuthenticationMode {
    login = 'login',
    registration = 'registration',
    registrationSuccess = 'registrationSuccess',
    recoveryPassword = 'recoveryPassword',
    recoveryPasswordSuccess = 'recoveryPasswordSuccess'
}

interface IProps {
    isOpenLoginModal: boolean
}

const Authentication = ({isOpenLoginModal}: IProps) => {

    const isLoading = useAppSelector(getIsAuthLoading)
    const [authenticationMode, setAuthenticationMode] = useState<EnumAuthenticationMode>(EnumAuthenticationMode.login)

    useEffect(() => {
        if (!isOpenLoginModal) {
            setAuthenticationMode(EnumAuthenticationMode.login)
        }
    }, [isOpenLoginModal])


    return (
        <div className={styles.authenticationBody}>
            <div className={clsx(
                styles.authenticationWrapper,
                isLoading && styles.authenticationWrapper__hide
            )}>
                {authenticationMode === EnumAuthenticationMode.login &&
                    <Login setAuthenticationMode={setAuthenticationMode}/>}
                {authenticationMode === EnumAuthenticationMode.registration &&
                    <Registration setAuthenticationMode={setAuthenticationMode}/>}
                {authenticationMode === EnumAuthenticationMode.registrationSuccess &&
                    <RegistrationSuccess />}
                {authenticationMode === EnumAuthenticationMode.recoveryPassword &&
                    <Authentication_RecoveryPassword setAuthenticationMode={setAuthenticationMode}/>}
                {authenticationMode === EnumAuthenticationMode.recoveryPasswordSuccess &&
                    <Authentication_RecoveryPasswordSuccess />}
            </div>

            <div className={clsx(
                styles.loadingWrapper,
                isLoading && styles.loadingWrapper__show
            )}>
                <CircleLoader color="#B29E7D" />
            </div>
        </div>
    );
};

export default Authentication;